import React from 'react';
import styled from 'styled-components';

interface VenueViewerShellProps {
  children: React.ReactNode;
}

const VenueViewerShell: React.FC<VenueViewerShellProps> = ({ children }) => (
  <Shell>{children}</Shell>
);

const Shell = styled.section`
  position: relative;
  flex: 0 0 29vw;
  width: 29vw;
  min-width: 29vw;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-bottom: 1px solid ${({ theme }) => theme.colors.color_Gray_04};
`;

export default VenueViewerShell;
